import { Numpad } from '@mobile/components/kartoy/numpad'
import { ScreenCardsPinSetup } from '@shared-ui/screens/cards/pin-setup'
import type { CardPinKeyboardProps } from '@shared-ui/screens/cards/pin-setup/direct'

function CardPinKeyboard({ value, onChange }: CardPinKeyboardProps) {
  return (
    <Numpad
      isDecimalKeyVisible={false}
      onPressKey={(key) => {
        if (key === 'backspace') onChange(value.slice(0, -1))
        else if (/^\d$/.test(key)) onChange(value + key)
      }}
    />
  )
}

export function ScreenCardPinSetup() {
  return <ScreenCardsPinSetup KeyboardComponent={CardPinKeyboard} />
}
